export default __webpack_public_path__ + "static/media/sa-girl.b20c19f0.webp";